var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,2.3C113.2,2.3,2.3,113.2,2.3,250c0,136.8,110.9,247.7,247.7,247.7c136.8,0,247.7-110.9,247.7-247.7 C497.7,113.2,386.8,2.3,250,2.3z M205.1,374.3c-76.7-10.6-98.6-41-98.6-41c4.6,0.6,9.4,0.8,14.2,0.8c27.9,0,53.6-9.5,73.9-25.5 c-26.1-0.5-48-17.7-55.6-41.3c3.6,0.7,7.4,1.1,11.2,1.1c5.4,0,10.7-0.7,15.7-2.1c-27.2-5.5-47.8-29.5-47.8-58.4c0-0.2,0-0.5,0-0.8 c8,4.5,17.2,7.1,27,7.5c-16-10.7-26.5-28.9-26.5-49.6c0-10.9,2.9-21.1,8.1-29.9c29.4,36,73.2,59.7,122.7,62.2 c-1-4.4-1.5-8.9-1.5-13.6c0-32.9,26.7-59.5,59.5-59.5c17.1,0,32.6,7.2,43.5,18.8c13.6-2.7,26.3-7.6,37.8-14.4 c-4.5,13.9-13.9,25.6-26.2,32.9c12-1.4,20.3-3.3,31-8c-8,11.9-14.9,21.1-26.5,29.5C413.7,333.2,281.7,385,205.1,374.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social_twitter.fccaa98f038299752f64c44db33d5d0c.svg";
export { ForwardRef as ReactComponent };